import React, { ReactNode, useEffect, useMemo } from "react";
import { TManageCaseApplication, TSubcase } from "./types";

export default function useSubcaseData(
  caseData: TManageCaseApplication | undefined,
  tab: Number,
) {
  const hasAtLeastOnePendingManualSubcase = useMemo(() => {
    if (!caseData?.subcases) {
      return false;
    }
    return caseData.subcases.some(
      (subcase) => !subcase.isAuto && subcase.status === 0,
    );
  }, [caseData?.subcases]);

  useEffect(() => {
    if (hasAtLeastOnePendingManualSubcase) {
      window.scrollTo({
        top: 10,
        behavior: "smooth",
      });
    }
  }, [hasAtLeastOnePendingManualSubcase]);

  const subcaseArray = useMemo<Array<TSubcase>>(() => {
    if (!caseData?.subcases) {
      return [];
    }

    let filteredSubcases;
    if (tab === 0) {
      filteredSubcases = caseData?.subcases.filter(
        (subcase) => !subcase.isAuto,
      );
    } else {
      filteredSubcases = caseData?.subcases.filter(
        (subcase) => !!subcase.isAuto,
      );
    }

    return filteredSubcases.sort(
      (a, b) => (b.priority || 0) - (a.priority || 0),
    );
  }, [tab, caseData?.subcases]);

  const manualSubcaseLength = useMemo<ReactNode>(() => {
    if (!caseData?.subcases) {
      return 0;
    }

    return caseData?.subcases.filter((subcase) => !subcase.isAuto).length;
  }, [caseData?.subcases]);

  const autoSubcaseLength = useMemo<ReactNode>(() => {
    if (!caseData?.subcases) {
      return 0;
    }

    return caseData?.subcases.filter((subcase) => !!subcase.isAuto).length;
  }, [caseData?.subcases]);

  return {
    hasAtLeastOnePendingManualSubcase,
    subcaseArray,
    manualSubcaseLength,
    autoSubcaseLength,
  };
}
